export const PDF_RENDER_SCALE = 1.5;
export const PDF_EXPORT_MAX_IMAGE_SIDE = 1600;
export const PDF_EXPORT_JPEG_QUALITY = 0.82;

const getExportDimensions = (width: number, height: number) => {
  const largestSide = Math.max(width, height);
  if (largestSide <= PDF_EXPORT_MAX_IMAGE_SIDE) {
    return { width, height };
  }

  const scale = PDF_EXPORT_MAX_IMAGE_SIDE / largestSide;
  return {
    width: Math.round(width * scale),
    height: Math.round(height * scale),
  };
};

export const getPdfPageExportImage = (
  page: HTMLImageElement,
  canvas = document.createElement("canvas"),
) => {
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Canvas context is not available");
  }

  const { width, height } = getExportDimensions(page.width, page.height);
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(page, 0, 0, width, height);

  return canvas.toDataURL("image/jpeg", PDF_EXPORT_JPEG_QUALITY);
};

export const buildBlurredPdfFile = (pages: HTMLImageElement[]) => {
  if (!pages.length) {
    throw new Error("Cannot export PDF without pages");
  }

  const { width, height } = pages[0];
  const orientation = width > height ? "landscape" : "portrait";
  const { jsPDF } = require("jspdf") as typeof import("jspdf");
  const doc = new jsPDF({ orientation });

  pages.forEach((page, index) => {
    if (index > 0) doc.addPage();

    doc.addImage(
      getPdfPageExportImage(page),
      "JPEG",
      0,
      0,
      doc.internal.pageSize.getWidth(),
      doc.internal.pageSize.getHeight(),
      undefined,
      "FAST",
    );
  });

  const pdfBlob = doc.output("blob");
  return new File([pdfBlob], "blurred-document.pdf", {
    type: "application/pdf",
  });
};
